<template>
  <div>
    <v-container>
      <div>
        <DateFilter
          @changeDate="postgpkmemberregisterdashboard"
          v-model="selectedDate"
        ></DateFilter>
      </div>

      <div class="mt-3">
        <v-layout row wrap>
          <v-flex xs4 sm3 class="pr-2">
            <div>Brand</div>
            <multiselect
              @input="postgpkmemberregisterdashboard"
              v-model="filter.brand"
              :options="brandOptions"
              selectLabel
              selectedLabel
              :allow-empty="false"
              deselect-label
              :searchable="false"
              open-direction="bottom"
            ></multiselect>
          </v-flex>
          <v-flex xs4 sm3 class="pr-2">
            <div>Type</div>
            <multiselect
              @input="postgpkmemberregisterdashboard"
              v-model="filter.type"
              :options="typeOptions"
              :allow-empty="false"
              selectLabel
              selectedLabel
              :searchable="false"
              deselect-label
              open-direction="bottom"
            ></multiselect>
          </v-flex>
          <v-flex xs4 sm3 class="pr-2">
            <div>Branch</div>
            <multiselect
              @input="postgpkmemberregisterdashboard"
              v-model="filter.branch"
              :options="location"
              selectLabel
              selectedLabel
              :searchable="false"
              open-direction="bottom"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>

      <div id="chart">
        <div v-if="loading" class="text-xs-center pa-5">
          <v-progress-circular indeterminate color="primary" size="50"> </v-progress-circular>
        </div>
        <apexchart
          v-show="!loading"
          :key="barchartkey"
          type="line"
          height="350"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter'
import axios from 'axios'
import moment from 'moment'
import apexchart from 'vue-apexcharts'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'

import config from '@/config'
export default {
  components: {
    DateFilter,
    Multiselect,
    apexchart
  },
  data() {
    return {
      memberdata: [],
      loading: false,
      typeOptions: ['register', 'renewal'],
      brandOptions: ['All', 'GRAM Pancakes', 'PABLO Cheese Tart', 'KOF'],
      location: [],
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      filter: {
        type: 'register',
        date_from: '',
        date_to: '',
        brand: 'All',
        branch: ''
      },

      series: [
        {
          name: '',
          data: [
            { x: moment('2018-02-12'), y: 76 },
            { x: moment('2018-02-14'), y: 9 },
            { x: moment('2018-02-16'), y: 26 }
          ]
        }
      ],
      barchartkey: new Date().getTime(),
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Member Interaction',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          type: 'datetime'
        }
      }
    }
  },
  async mounted() {
    this.getLocation()
    await this.postgpkmemberregisterdashboard()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    checkActive(item) {
      return this.filter.brand == item
    },
    getLocation() {
      axios
        .get(`${config.serverUrl}gpklocation`, {
          headers: {
            AUTHORIZATION: 'Bearer xxx xxx'
          },
          params: {
            pageid: this.selectedBot.pageid
          }
        })
        .then((response) => {
          if (response.data.responsecode == 200) {
            this.location = response.data.data.map((el) => el.branch)
          }
        })
    },
    postgpkmemberregisterdashboard() {
      return new Promise((resolve) => {
        this.loading = true

        var data = {
          pageid: this.selectedBot.pageid, // REQUIRED
          type: this.filter.type, // register, renew  ** default ให้เป็น register ** REQUIRED
          date_from: this.selectedDate.start,
          date_to: this.selectedDate.end,
          brand: this.filter.brand == 'All' ? '' : this.filter.brand,
          branch: this.filter.branch // สาขา
        }
        api.postgpkmemberregisterdashboard(data, (err, response) => {
          var memberdata = response.data.map((el) =>
            new Date(moment(el.timestamp).format('YYYY-MM-DD')).getTime()
          )
          var counts = {}
          memberdata.forEach(function (x) {
            counts[x] = (counts[x] || 0) + 1
          })
          var series = []
          for (const item in counts) {
            series.push({ x: parseInt(item), y: counts[item] })
          }
          this.series[0].data = series
          this.barchartkey = new Date().getTime()
          this.loading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/grampablokof/MemberInteraction.vue